/**
 * @voltxampere/ui — IRFP240 NMOS power MOSFET variant (Sprint 44-2)
 *
 * Reference: Vishay/IRF IRFP240 datasheet — TO-247AC power NMOS.
 *   V_DSS = 200 V         (drain-source breakdown)
 *   I_D = 20 A            (continuous drain current at T_C = 25°C)
 *   R_DS(on) = 0.18 Ω     (at V_GS = 10 V, I_D = 12 A)
 *   V_GS(th) = 4.0 V      (typical, range 2-4 V)
 *   gfs = 12 S            (forward transconductance — power MOSFET)
 *   Vt0 = 4.0 V
 *   Kp  = 12 A/V²         (high transconductance — power MOSFET)
 *   Lambda = 0.01 1/V     (channel-length modulation)
 *
 * Power package: TO-247AC, R_th(j-c) = 0.83°C/W (Sprint 38-5
 * R_thermal entry — already in table for IRF540 family analog).
 *
 * Engine zero-diff invariant honored — canonical `mosfet-nmos`
 * engine type via schemaType (Sprint 38-2 IRF540 pattern reuse,
 * higher voltage rating).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { nmos } from "../nmos.js";
export const powerMosfetIrfp240 = {
    id: "irfp240",
    nameTr: "IRFP240 (NMOS güç, 200V/20A, TO247)",
    nameEn: "IRFP240 (NMOS power, 200V/20A, TO247)",
    shortcut: "M",
    category: "active",
    viewBox: nmos.viewBox,
    terminals: nmos.terminals,
    defaultLabel: "M",
    defaultValue: "IRFP240",
    schemaType: "mosfet-nmos",
    defaultParams: { Vt0: 4.0, Kp: 12, Lambda: 0.01 },
    renderSVG: () => nmos.renderSVG(),
};
//# sourceMappingURL=power-mosfet-irfp240.js.map